export const BACK_TO_DASHBOARD_TEXT = '< Back to Dashboard'
